import React from "react";

import { useRecoilValue } from "recoil";

import OrganizationData from "../data/OrganizationData";
import organizationDataAtom from "../atoms/organizationDataAtom";

export type OrganizationDataProps = {
  uid: string;
};

export type OrganizationDataByOrgIdProps = {
  organizationId: string;
};

export const useOrganizationDataByOrgId = ({
  organizationId,
}: OrganizationDataByOrgIdProps) => {
  const [organizationData, setOrganizationData] = React.useState();
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!organizationId) {
      return;
    }

    const getData = async () => {
      setLoading(true);
      const response: any =
        await OrganizationData.getOrganizationById(organizationId);
      setOrganizationData(response);
      setLoading(false);
    };
    getData();
  }, [organizationId]);
  return { organizationData, loading };
};

const useOrganizationData = ({ uid }: OrganizationDataProps) => {
  const [organizationData, setOrganizationData] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const orgState = useRecoilValue(organizationDataAtom);

  React.useEffect(() => {
    if (!uid) {
      return;
    }

    const getData = async () => {
      setLoading(true);
      const response: any = await OrganizationData.getOrganization(uid);
      setOrganizationData(response);
      setLoading(false);
    };
    getData();
  }, [uid, orgState]);
  return { organizationData, loading };
};

export default useOrganizationData;
